import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, BLUE_500, Card, InfoIcon, InfoTag, Tooltip, Typography, WHITE, getTestId, isValidObject, tokens } from '@airtel/air-design-system';
import { Fragment, useState } from 'react';
import { Image, Pressable, View } from 'react-native';
import { ButtonWidget } from '../../button-widget';
import { getDynamicDataCardWidgetStyles } from '../DynamicDataCardWidgetStyles';
export var DynamicCardImg = inventoryProp => {
  var _a, _b, _c, _d;
  var id = inventoryProp.id,
    headingType = inventoryProp.headingType,
    infoTagMarginBottom = inventoryProp.infoTagMarginBottom,
    imageProps = inventoryProp.imageProps,
    _inventoryProp$resize = inventoryProp.resizeMode,
    resizeMode = _inventoryProp$resize === void 0 ? 'cover' : _inventoryProp$resize,
    logoResizeMode = inventoryProp.logoResizeMode,
    buttonProps = inventoryProp.buttonProps,
    heading = inventoryProp.heading,
    description = inventoryProp.description,
    _inventoryProp$headin = inventoryProp.headingNoOfLines,
    headingNoOfLines = _inventoryProp$headin === void 0 ? 1 : _inventoryProp$headin,
    _inventoryProp$descrp = inventoryProp.descrptionNoOfLines,
    descrptionNoOfLines = _inventoryProp$descrp === void 0 ? 2 : _inventoryProp$descrp,
    infoTagSubType = inventoryProp.infoTagSubType,
    infoTagText = inventoryProp.infoTagText,
    infoTagSize = inventoryProp.infoTagSize,
    infoTagType = inventoryProp.infoTagType,
    infoIconName = inventoryProp.infoIconName,
    _inventoryProp$testID = inventoryProp.testID,
    testID = _inventoryProp$testID === void 0 ? 'DynamicDataCardImg' : _inventoryProp$testID,
    logoUrl = inventoryProp.logoUrl,
    showLogo = inventoryProp.showLogo,
    _inventoryProp$logoSt = inventoryProp.logoStyles,
    logoStyles = _inventoryProp$logoSt === void 0 ? {} : _inventoryProp$logoSt,
    infoIconPosition = inventoryProp.infoIconPosition,
    onUserAction = inventoryProp.onUserAction,
    style = inventoryProp.style,
    onCardPressMetaData = inventoryProp.onCardPressMetaData,
    _inventoryProp$isCard = inventoryProp.isCardOnPressDisabled,
    isCardOnPressDisabled = _inventoryProp$isCard === void 0 ? true : _inventoryProp$isCard,
    _inventoryProp$showCt = inventoryProp.showCtaAtBottom,
    showCtaAtBottom = _inventoryProp$showCt === void 0 ? false : _inventoryProp$showCt,
    _inventoryProp$showIn = inventoryProp.showInfoIcon,
    showInfoIcon = _inventoryProp$showIn === void 0 ? false : _inventoryProp$showIn,
    tooltipProps = inventoryProp.tooltipProps,
    _inventoryProp$wrappe = inventoryProp.wrapperStyle,
    wrapperStyle = _inventoryProp$wrappe === void 0 ? {} : _inventoryProp$wrappe;
  var widgetStyles = getDynamicDataCardWidgetStyles((_b = (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.leftCta) === null || _a === void 0 ? void 0 : _a.buttonType) !== null && _b !== void 0 ? _b : 'primary', showLogo, infoTagMarginBottom);
  var isButtonPropsValid = isValidObject(buttonProps) && !Array.isArray(buttonProps);
  var onCardPressHandler = () => {
    onUserAction(Object.assign({
      id
    }, onCardPressMetaData), inventoryProp);
  };
  var Wrapper = isCardOnPressDisabled ? Fragment : Pressable;
  var wrapperProps = isCardOnPressDisabled ? {} : {
    testID: 'dynamic-data-card-container',
    onPress: onCardPressHandler,
    style: wrapperStyle
  };
  var _useState = useState(false),
    showToolTip = _useState[0],
    setShowTooltip = _useState[1];
  var onInfoIconPress = (iconPressMetaData, setShowTooltip, id) => {
    !iconPressMetaData && setShowTooltip(!showToolTip);
    iconPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, iconPressMetaData)));
  };
  return _jsx(_Fragment, {
    children: !!isValidObject(imageProps) && _jsx(Wrapper, Object.assign({}, wrapperProps, {
      children: _jsxs(Card, Object.assign({
        style: [widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.cardOuterContainer, style],
        noPadding: true
      }, {
        children: [!!showInfoIcon && (!!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.onInfoIconPressMetaData) || !!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.text)) && _jsx(Tooltip, Object.assign({
          text: (_c = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.text) !== null && _c !== void 0 ? _c : '',
          position: "bottom-start",
          offset: {
            x: -12,
            y: -6
          },
          isVisible: showToolTip,
          onClose: () => {
            setShowTooltip(false);
          },
          style: widgetStyles.infoIconTooltip,
          testID: (_d = tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.id) !== null && _d !== void 0 ? _d : 'InfoList-Child-RightToolTip',
          autoHide: true,
          autoHideTimeout: 3000
        }, tooltipProps, getTestId(testID, 'toolTip'), {
          children: _jsx(Pressable, Object.assign({
            onPress: () => onInfoIconPress(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.onInfoIconPressMetaData, setShowTooltip, 'infoIconPress')
          }, {
            children: _jsx(InfoIcon, Object.assign({
              color: BLUE_500,
              fill: WHITE,
              fontSize: tokens.spacing.SPACING_16,
              accessibilityLabel: "info icon"
            }, getTestId(testID, 'infoIcon')))
          }))
        })), _jsxs(View, Object.assign({
          style: widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.imageContainerCard
        }, {
          children: [!!isValidObject(imageProps) && _jsx(Image, Object.assign({
            source: {
              uri: imageProps === null || imageProps === void 0 ? void 0 : imageProps.imageUrl
            },
            style: widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.imageCard,
            resizeMode: resizeMode
          }, getTestId(testID, 'imageUrl'))), _jsx(View, Object.assign({
            style: widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.logoContainerCard
          }, {
            children: !!showLogo && _jsx(Image, Object.assign({
              source: {
                uri: logoUrl === null || logoUrl === void 0 ? void 0 : logoUrl.imageUrl
              },
              style: [widgetStyles.logoCard, logoStyles],
              resizeMode: logoResizeMode !== null && logoResizeMode !== void 0 ? logoResizeMode : resizeMode
            }, getTestId(testID, 'showLogo')))
          }))]
        })), _jsxs(View, Object.assign({
          style: widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.contentContainer
        }, {
          children: [_jsxs(View, Object.assign({
            style: widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.textWrapper
          }, {
            children: [!!heading && _jsx(View, Object.assign({
              style: widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.headingContainerStyle
            }, {
              children: _jsx(Typography, Object.assign({
                type: headingType ? headingType : 'body-single-line-md-bold',
                color: BLACK_900,
                numberOfLines: headingNoOfLines,
                text: heading
              }, getTestId(testID, 'heading')))
            })), !!description && _jsx(View, Object.assign({
              style: widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.descriptionContainerStyle
            }, {
              children: _jsx(Typography, Object.assign({
                type: "body-para-xs",
                color: BLACK_700,
                text: description,
                numberOfLines: descrptionNoOfLines
              }, getTestId(testID, 'description')))
            })), !!infoTagText && _jsx(InfoTag, Object.assign({
              text: infoTagText,
              subType: infoTagSubType,
              style: widgetStyles.infoTagMargin,
              type: infoTagType,
              size: infoTagSize,
              iconName: infoIconName,
              iconPosition: infoIconPosition
            }, getTestId(testID, 'showInfoTag')))]
          })), !showCtaAtBottom && isButtonPropsValid && _jsx(View, Object.assign({
            style: widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.buttonWrapper
          }, {
            children: _jsx(ButtonWidget, Object.assign({
              id: id
            }, buttonProps, getTestId(testID, 'ButtonWidgetContainer'), {
              onUserAction: onUserAction
            }))
          }))]
        })), !!showCtaAtBottom && isButtonPropsValid && _jsx(View, Object.assign({
          style: [widgetStyles === null || widgetStyles === void 0 ? void 0 : widgetStyles.ctaContainerStyle]
        }, {
          children: _jsx(ButtonWidget, Object.assign({
            id: id
          }, buttonProps, getTestId(testID, 'ButtonWidgetContainerBottom'), {
            onUserAction: onUserAction
          }))
        }))]
      }))
    }))
  });
};